import Vue from 'vue'
import VueRouter from 'vue-router'
import GoodsCode from '../views/GoodsCode.vue'
import GoodsCodeCollection from '../views/GoodsCodeCollection.vue'
import BaseParam from '../views/BaseParam.vue'
import BaseParamCollection from '../views/BaseParamCollection.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/goods-code'
  },
  {
    path: '/goods-code',
    name: 'GoodsCode',
    component: GoodsCode
  },
  {
    path: '/goods-code-collection',
    name: 'GoodsCodeCollection',
    component: GoodsCodeCollection
  },
  {
    path: '/base-param',
    name: 'BaseParam',
    component: BaseParam
  },
  {
    path: '/base-param-collection',
    name: 'BaseParamCollection',
    component: BaseParamCollection
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router